import {useSelector} from 'react-redux';

function useGetAssistants() {
  return useSelector((state: any) => state.assistants.collaborator);
}

export default useGetAssistants;
